import fixIframes from './fix_iframe_protocol_util';

export default () => {
    // fix legacy content
    // todo: fix this on migration
    fixIframes();

    // Expose variables, mostly for legacy support
    window.FC = window.FC || {};
    window.FC.plugins = window.FC.plugins || {};
    window.FC.vent = window.FC.vent || {};
    window.FC.vent.on = function () {};
    window.FC.ads = window.FC.ads || {};
};
